import {
  CubeIcon,
  PaintBrushIcon,
} from "@patternfly/react-icons";

export const appearanceThemes = [
  {
    id: "default",
    label: "Domyślny",
    description: "Use the standard PatternFly theme.",
    icon: CubeIcon,
  },
  {
    id: "project-felt",
    label: "Felt",
    description: "Use the Project Felt design theme.",
    icon: PaintBrushIcon,
  },
];